<template>
  <div id="app">
    <!-- 路由视图，用于显示当前页面组件 -->
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  // 使用 Vue 原型挂载全局数据（需在 main.js 中定义）
  // 或者改用 Vuex，这里保留原结构便于理解
  data() {
    return {
      // 如果需要响应式全局数据，可放在这里并通过 provide/inject 传递
    };
  },
  created() {
    // 对应原 onLaunch，在应用初始化时执行一次
    this.initApp();
  },
  mounted() {
    // 对应原 onShow 中的逻辑 + mounted 中的逻辑
    this.handleHashRedirect();

    // 监听路由变化，处理 hash 变化（如果页面不刷新）
    window.addEventListener("popstate", this.handleHashRedirect);
  },
  beforeDestroy() {
    // 对应原 onHide，清理监听器
    window.removeEventListener("popstate", this.handleHashRedirect);
  },
  methods: {
    // 应用初始化逻辑（原 onLaunch 内容）
    initApp() {
      console.log("App Created");
      // 原 uni.getStorage 改为 localStorage
      // const token = localStorage.getItem('accessToken');
      // if (token) {
      //   console.log('缓存存在');
      //   this.$router.replace('/loT/index/index2'); // 注意路径需匹配路由配置
      // } else {
      //   console.log('缓存不存在');
      //   this.$router.replace('/login/Carmine');
      // }
    },

    // 处理 URL hash 重定向（原 handleHashRedirect）
    handleHashRedirect() {
      const hash = window.location.hash;

      if (!hash) return;

      // Vue Router 默认使用 #/ 形式，移除开头的 '#'
      const path = hash.startsWith("#/") ? hash.slice(1) : hash;
      const [routePath, queryStr] = path.split("?");
      const params = new URLSearchParams(queryStr || "");

      console.log(routePath, "?");
      if (routePath === "/qrcode") {
        const sn = params.get("sn");
        if (sn) {
          this.printingQuery(sn);
        }
        return;
      }

      if (routePath === "/qrcode/achangeInvent") {
        const iccid = params.get("iccid");
        if (iccid) {
          this.printingQuery(iccid);
        }
        return;
      }
    },

    // 打印查询逻辑（原 printingQuery）
    printingQuery(sn) {
      const currentUrl = window.location.origin;
      this.$REQ(this.$api.printingQuery, { sn, url: currentUrl }, "get")
        .then((res) => {
          if (res.data && res.data.url) {
            let redirectUrl = res.data.url;
            if (res.data.key) {
              redirectUrl += res.data.key;
            }
            window.location.href = redirectUrl;
            return;
          } else {
            // 没有获取到跳转地址时执行降级
            this.redirectWithParam("http://help.ha818.cn", { sn });
          }
        })
        .catch((err) => {
          // 打印具体错误信息，便于定位（例如 res.msg 的内容）
          console.error("打印接口失败，错误详情：", err);
          return;
          // 降级跳转，注意移除原代码中的 return 语句
          this.redirectWithParam("http://help.ha818.cn", { sn });
        });
    },

    // 带参数跳转（原 redirectWithParam）
    redirectWithParam(pagePath, params) {
      // 将 params 对象转换为查询字符串
      const queryString = Object.keys(params)
        .map(
          (key) =>
            `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`
        )
        .join("&");

      // 如果 pagePath 已经包含 '?'，则需要用 '&' 拼接，否则用 '?' 拼接
      const separator = pagePath.includes("?") ? "&" : "?";
      const url = queryString
        ? `${pagePath}${separator}${queryString}`
        : pagePath;

      // 使用 window.location.href 跳转
      window.location.href = url;
    },

    // 清除 URL 中的 hash（原 clearHash）
    clearHash() {
      if (window.history.replaceState) {
        const newUrl = window.location.pathname + window.location.search;
        window.history.replaceState(null, "", newUrl);
        console.log("已清除 hash");
      }
    },
  },
};
</script>
<style scoped>
.wad {
  color: white;
}
</style>
